import { Box, Button, buttonClasses } from '@mui/material';
import React, { FC } from 'react';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import ActionsButton from 'src/components/ActionsButton';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { detailsDrawerInit } from 'src/DetailsDrawer/store/detailsDrawerSlice';

type Props = ReturnType<typeof mapDispatchToProps>;

const HeaderContent: FC<Props> = ({ createReceipt }) => {
  return (
    <Box display="flex" flexWrap="nowrap" alignItems="center" gap={1}>
      <Button
        variant="text"
        startIcon={
          <AddOutlinedIcon
            color="inherit"
            sx={{ fontSize: '12px !important' }}
          />
        }
        sx={{
          fontSize: 12,
          color: 'inherit',
          [`& .${buttonClasses.startIcon}`]: {
            margin: 0,
            marginInlineEnd: 0.5,
          },
        }}
        onClick={createReceipt}
      >
        הוספת חשבונית
      </Button>
      <ActionsButton label="פעולות" />
    </Box>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  createReceipt: () => dispatch(detailsDrawerInit({ type: 'RECEIPTS_CREATE' })),
});

export default connect(null, mapDispatchToProps)(HeaderContent);
